import {
  KisiBrandConfig,
  KisiGroup,
  KisiGroupMapping,
  KisiPlace,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type KisiApiType = ReturnType<typeof kisiApi>;
const kisiApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    saveApiKey(apiKey: string) {
      return axiosInstance.put(`${clubPrefix}kisi/save-api-key/${apiKey}`);
    },
    brandConfig() {
      return axiosInstance.get<KisiBrandConfig>(
        `${clubPrefix}kisi/brand-config`,
      );
    },
    generateSignatureKey() {
      return axiosInstance.get<{ secretKey: string }>(
        `${clubPrefix}kisi/api-signature-key`,
      );
    },
    fetchPlaces() {
      return axiosInstance.get<KisiPlace[]>(`${clubPrefix}catalog/kisi/places`);
    },
    fetchGroups() {
      return axiosInstance.get<KisiGroup[]>(`${clubPrefix}catalog/kisi/groups`);
    },
    initialize(
      kisiPlaceId: string,
      membershipToGroupMap: { [k: number]: string },
      facilityToGroupMap: { [k: number]: string },
    ) {
      return axiosInstance.post(`${clubPrefix}kisi/initialize`, {
        placeId: kisiPlaceId,
        membershipsToGroups: membershipToGroupMap,
        facilitiesToGroups: facilityToGroupMap,
      });
    },
    fetchGroupMappings() {
      return axiosInstance.get<KisiGroupMapping[]>(
        `${clubPrefix}kisi/group-mappings`,
      );
    },
    modify(params: {
      membershipId?: number;
      facilityId?: number;
      // Sending a null kisiGroupId removes the membership mapping
      kisiGroupId: string | null;
    }) {
      return axiosInstance.patch(`${clubPrefix}kisi/modify`, params);
    },
    resetAccess(memberId: string) {
      return axiosInstance.put(`${clubPrefix}kisi/reset-access/${memberId}`);
    },
  };
};

export default kisiApi;
